"use client";

import React from "react";
import { createAppKit } from "@reown/appkit/react";
import {
  bsc,
} from "@reown/appkit/networks";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";

// Custom Blocksafu Dev network
const blocksafuDev = {
  id: 31337,
  name: "Blocksafu Dev",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["http://dev-safubit:8545"],
    },
    public: {
      http: ["http://dev-safubit:8545"],
    },
  },
  blockExplorers: {
    default: {
      name: "Blocksafu Dev Explorer",
      url: "http://dev-safubit:8545",
    },
  },
};

const projectId = "754f8b3700af688d708d60b87c7473ce";

const metadata = {
  name: "Blocksafu BSC",
  description: "Blocksafu BSC Platform",
  url: "https://blocksafu.com",
  icons: ["https://blocksafu.com/android-512x512.png"],
};

// Determine networks based on domain
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const networks = isLocalhost ? [bsc, blocksafuDev] : [bsc];

createAppKit({
  adapters: [new EthersAdapter()],
  networks: networks,
  metadata,
  projectId,
  features: {
    analytics: true,
  },
  defaultNetwork: bsc,
});

export function Web3EVMModal({ children }) {
  return <div className="">{children}</div>;
}
